import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class SnapshotTypeService {
    constructor(http) {
        this.http = http;
        this.singular = 'snapshot-type';
        this.plural = 'snapshot-types';
        this.editor = PLATFORM.moduleName('pages/system-fields/snapshot-types/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`snapshot-types/filter/${loadOptions}`);
        return await response.json();
    }

    async create(snapshotType) {
        await this.http.fetch('snapshot-types', { method: 'POST', body: json(snapshotType) });
    }

    async update(snapshotType) {
        await this.http.fetch(`snapshot-types/${snapshotType.id}`, { method: 'PUT', body: json(snapshotType) });
    }

    async delete(id) {
        await this.http.fetch(`snapshot-types/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`snapshot-types/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`snapshot-types/top-three/${query}`);
        return await response.json();
    }
}